import { useQuery } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql-client";
import { PublicCompanyQuery } from "@/queries";
import type { PublicCompany } from "@repo/types";

export function usePublicCompany(companyId: string | undefined) {
  return useQuery<PublicCompany>({
    queryKey: ["publicCompany", companyId],
    queryFn: () =>
      graphqlClient
        .request<{
          getPublicCompanyInfo: PublicCompany;
        }>(PublicCompanyQuery, { companyId: parseInt(companyId ?? "", 10) })
        .then((res) => res.getPublicCompanyInfo),
    enabled: !!companyId,
  });
}
